import dynamic from "next/dynamic";
import { useTranslations } from "next-intl";

import IconCountry from "@/icons/icon-country";
import { useCountryDialog } from "~/contexts/country-dialog-context";

import styles from "./country-dialog.module.scss";
import Dialog from "./dialog";
import Icon from "./icon";
const CountryDialogInner = dynamic(() => import("./country-dialog-inner"));

type Props = {
  onAfterOpen?: () => void;
  onAfterClose?: () => void;
};

export default function CountryDialog({ onAfterOpen, onAfterClose }: Props) {
  const t = useTranslations();
  const { isOpen, close } = useCountryDialog();

  return (
    <Dialog
      isOpen={isOpen}
      title={
        <>
          <Icon icon={IconCountry} aria-hidden />
          <span id="changecountry-dialog-headline">{t("generic.select_your_country")}</span>
        </>
      }
      onClose={close}
      onAfterOpen={onAfterOpen}
      onAfterClose={onAfterClose}
      customStyles={styles}
    >
      <CountryDialogInner />
    </Dialog>
  );
}
